import {connectCurrentRefinements} from 'react-instantsearch-dom';
import {useTranslation} from "react-i18next";

const ClearRefinements = ({items, refine, onMessageCancel}) => {

    const {t, i18n} = useTranslation();

    const _onClearRefinements = () => {
        if (items.length) {
            refine(items);
        }
        onMessageCancel();
    }

    return (
        <button onClick={() => _onClearRefinements()}
                className="btn btn--gray btn--outline">Cancel Message &
            Return
            Back
        </button>
    );
}

const CancelBtn = connectCurrentRefinements(ClearRefinements);
export default CancelBtn;
